import jsPDF from "jspdf";
import font from "../assets/fonts/Play-Bold-normal";
export const generateReceipt = (receipt, customer) => {
  if (!receipt || !customer) return false;

  const doc = new jsPDF();

  // ============ Header ============
  doc.addFileToVFS("Play-Bold-normal.ttf", font);
  doc.addFont("Play-Bold-normal.ttf", "Play-Bold", "normal");
  doc.setFont("Play-Bold");
  doc.setFontSize(30);
  doc.setTextColor("#ca8a04");
  doc.text("POSH", 16, 16);

  // ============ Receipt Date ============
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(8);
  doc.setTextColor("#000");
  doc.text(`Date: ${receipt.date_created}`, 168, 16);

  // ============ Title ============
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor("#000");
  doc.text("Invoice", 18, 36);
  doc.setFontSize(10);
  doc.setTextColor(122, 121, 121);
  doc.setFont("Helvetica", "normal");
  doc.text(`Reference ID: ${receipt.id}`, 118, 36);

  // ============ Frame ============
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(10);
  doc.line(16, 40, 200, 40);
  doc.text("Date", 22, 46);
  doc.text("Description", 42, 46);
  doc.text("Amount", 176, 46);
  doc.line(16, 50, 200, 50);

  // ============ Items ============
  let y = 60;
  doc.setFont("Helvetica", "normal");
  doc.setTextColor("#000");
  doc.setFontSize(10);
  doc.text(receipt.date_created, 22, y);
  doc.text(receipt.description, 42, y);
  doc.text("$"+receipt.subtotal, 176, y);

  // ============ Additional Charges ============
  y = y + 10;
  doc.line(16, y, 200, y);
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(10);
  doc.setTextColor(122, 121, 121);
  doc.text("Subtotal", 132, y + 6);
  doc.text("Taxes", 132, y + 12);
  doc.text("Total", 132, y + 18);
  doc.text("Status", 132, y + 24);
  doc.text("Due Date", 132, y + 30);
  doc.setTextColor("#000");
  doc.text("$"+receipt.subtotal, 176, y + 6);
  doc.text("$"+receipt.taxes, 176, y + 12);
  doc.text("$"+receipt.amount, 176, y + 18);
  doc.text(receipt.status, 176, y + 24);
  doc.text(receipt.due_date, 176, y + 30);
  y = y + 36;
  doc.line(124, y, 200, y);

  // ============ Booking ============
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor("#000");
  y = y + 26;
  doc.text("Booking Information", 16, y);
  doc.setFontSize(10);
  doc.setTextColor(122, 121, 121);
  doc.setFont("Helvetica", "normal");
  doc.text(`Booking ID: ${receipt.booking.id}`, 118, y);

  // ============ Info ============
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(10);
  y = y + 4;
  doc.line(16, y, 200, y);
  y = y + 6;
  doc.text("Vehicle", 22, y);
  doc.text("From", 140, y);
  doc.text("To", 176, y);
  y = y + 4;
  doc.line(16, y, 200, y);
  y = y + 6;
  doc.setFont("Helvetica", "normal");
  doc.text(
    `${receipt.vehicle.make} ${receipt.vehicle.model} ${receipt.vehicle.year}`,
    22,
    y
  );
  doc.text(receipt.booking.start_date, 140, y);
  doc.text(receipt.booking.end_date, 176, y);
  y = y + 4;
  doc.line(16, y, 200, y);

  // ============ Customer Info ============
  doc.setFont("Helvetica", "bold");
  doc.setFontSize(14);
  doc.setTextColor("#000");
  y = y + 26;
  doc.text("Customer Information", 16, y);
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(122, 121, 121);
  doc.text(`Customer ID: ${customer.id}`, 118, y);
  doc.setTextColor("#000");
  doc.line(16, y + 4, 200, y + 4);
  y = y + 10;
  doc.text(`${customer.firstName} ${customer.lastName}`, 16, y);
  doc.text(customer.email, 16, y + 12);
  doc.text(customer.phone, 16, y + 6);

  // ============ Footer ============
  doc.setFont("Helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Copyright © 2023 POSHIT Inc. All rights reserved.", 10, 286);
  doc.text("100 Tradecenter Drive, Woburn, MA 01801", 78, 286);
  doc.text("ph: +1 (413) 210-346", 138, 286);
  doc.text("support@poshcars.io", 172, 286);

  // ============ Save ============
  doc.save("receipt.pdf");
  return true;
};
